import {SET_USER_EMAIL} from "./UAM"

export const setUserEmail = (value) => {
  console.log("User Email in Action", value);
  return {
    type: SET_USER_EMAIL,
    email: value
  };
};